<div class="top">
	<div
		class="video-and-image"
		[class.hidden]="!captureStream() && !imagePreviewSrc()"
	>
		<video
			#video
			[class.hidden]="!captureStream() || !!imageSrc()"
			(click)="takePicture()"
		></video>
		<div>
			<img
				#image
				[src]="imagePreviewSrc()"
				[class.hidden]="!imagePreviewSrc()"
				[style.height]="forceImageHeight() || 'auto'"
				[style.width]="forceImageWidth() || 'auto'"
			/>
		</div>
	</div>
	<div class="actions">
		<input
			#file
			type="file"
			class="hidden"
			[accept]="allowedFileMimeTypes()?.join(',') || '*'"
			(change)="onFileSelected($event)"
		/>
		@if (allowCamera()) {
			@if (imageSrc()) {
				<button
					mat-raised-button
					(click)="useImage()"
					aria-label="Use this picture"
					color="primary"
				>
					<mat-icon>check</mat-icon>
					Use this picture
				</button>
				<button
					mat-raised-button
					(click)="startCapturing()"
					aria-label="Retake"
					color="secondary"
				>
					<mat-icon>replay</mat-icon>
					Retake
				</button>
			}
			@if (captureStream() || imageSrc()) {
				<button
					mat-raised-button
					(click)="cancelCapture()"
					aria-label="Cancel"
					color="warn"
				>
					<mat-icon>close</mat-icon>
					Cancel
				</button>
			}
			@if (!captureStream() && !imageSrc()) {
				<button
					mat-raised-button
					(click)="startCapturing()"
					aria-label="Take a picture"
					color="primary"
				>
					<mat-icon>photo_camera</mat-icon>
					Take a picture
				</button>
			}
		}
		@if (allowFileSelection()) {
			<button
				mat-raised-button
				(click)="file.click()"
				aria-label="Select a file"
				color="primary"
			>
				<mat-icon>attach_file</mat-icon>
				Upload a file
			</button>
		}
	</div>
</div>
